import { Size } from 'components/common/SizeDisplay'
import { API_BASEPATH, Err } from '.'
import { ShipmentCategory } from 'utils/data'

export type Payload = {
  countryCode?: string | null
  size?: Size | null
  medium?: string | null
  shipmentCategory?: ShipmentCategory | null
  buyingPrice?: number | null
  framed?: boolean
  galleryName: string | undefined
  shipmentWeightOverride: number | undefined
}

export type Response =
  | {
      error?: Err
    }
  | number

export const getShippingCost = async (payload: Payload) => {
  const response = await fetch(`${API_BASEPATH}/api/shipment/shipping-price`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
    },
  })
  const data = await response.json()
  return data as Response
}
